








































import Vue from 'vue'
import { getRelatedCmsMagazines } from '@/categories/helper'
import {
  getCMSMagazineSection_category_relatedColumnCmsMagazines as ColumnMagazine,
  getCMSMagazineSection_category_relatedCmsCategories as CmsCategory
  } from '../types/getCMSMagazineSection'
import { app } from '../config/selectors'
import { captureMessage } from '@sentry/browser'

export default Vue.extend({
  data(): {
    columnMagazines: ColumnMagazine[]
    cmsCategories: CmsCategory[]
  } {
    return {
      columnMagazines:[],
      cmsCategories: []
    }
  },
  async mounted() {
    const mountEl = document.querySelector(app.searchFilterMountEl)
    if (!mountEl) return

    const categoryId = mountEl.getAttribute('data-category-id')
    if (!categoryId) return

    try {
      const { data, errors } = await getRelatedCmsMagazines(categoryId)
      if (data.category.relatedColumnCmsMagazines) {
        this.columnMagazines = data.category.relatedColumnCmsMagazines as ColumnMagazine[]
      }

      if (data.category.relatedCmsCategories) {
        this.cmsCategories = data.category.relatedCmsCategories as CmsCategory[]
      }

      if (errors) {
        captureMessage(`Fetching related cms magazines and categories has errors: ${JSON.stringify(errors)}`)
      }
    } catch (error) {
      captureMessage(`Failed to fetch related cms magazines and categories: ${JSON.stringify(error)}`)
    }
  }
})
